// extracted by mini-css-extract-plugin
module.exports = {"unindented-list":"style_unindented-list__qCbXK","indented-list":"style_indented-list__59me-"};